import axios from 'axios';
import { SellerUnit, UnitType } from '../types/unit.types';

const BASE = process.env.REACT_APP_API_URL;
const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export interface UnitListResponse {
    units : SellerUnit[];
    total : number;
    page  : number;
    pages : number;
}

export const unitService = {

    getUnits: (params: Record<string, any>, token: string) =>
        axios.get<UnitListResponse>(`${BASE}/seller/units`, { ...auth(token), params }),

    createUnit: (data: { name: string; symbol: string; type: UnitType }, token: string) =>
        axios.post<{ unit: SellerUnit }>(`${BASE}/seller/units`, data, auth(token)),

    updateUnit: (id: string, data: Partial<{ name: string; symbol: string; status: string }>, token: string) =>
        axios.put<{ unit: SellerUnit }>(`${BASE}/seller/units/${id}`, data, auth(token)),

    deleteUnit: (id: string, token: string) =>
        axios.delete(`${BASE}/seller/units/${id}`, auth(token)),

    toggleStatus: (id: string, status: 'ACTIVE' | 'INACTIVE', token: string) =>
        axios.patch(`${BASE}/seller/units/${id}/status`, { status }, auth(token)),
};
